import { useColorMode } from "@chakra-ui/react";

import { G1Style } from "@/theme/G1Style";

export const useColorContext = () => {
    const { colorMode } = useColorMode() ;
    G1Style.setCurrentContext(colorMode) ;
}